import FileSaver from "file-saver";

export async function saveOrPrintBlob(file: Blob) {
  const url = URL.createObjectURL(file);

  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    FileSaver.saveAs(file, "Report.pdf");
    return Promise.resolve();
  }

  if (navigator.userAgent.toLowerCase().includes("firefox")) {
    window.open(url);
    return Promise.resolve();
  }

  return new Promise<void>((resolve, reject) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `Report.pdf`,
    );

    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  });
}
